const Wdata = [
  {
    id: 1,
    cover: "/images/menu/11.jpeg",
  },
  {
    id: 2,
    cover: "/images/menu/22.jpeg",
  },
  {
    id: 3,
    cover: "/images/menu/33.jpeg",
  },
  {
    id: 4,
    cover: "/images/menu/44.jpeg",
  },
  {
    id: 5,
    cover: "/images/menu/55.jpeg",
  },
];
export default Wdata;
